export { default as LifestyleSearchProductsButton } from './LifestyleSearchProductsButton';
